import AccountSidebar from './AccountSidebar'
import Footer from '/web/shared/aifans/Footer'
import HeaderContainer from '/web/shared/aifans/HeaderContainer'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { contentfulClient, TypePolicySkeleton } from '/web/shared/aifans/lib/contentful-util'
import { createEffect, createSignal } from 'solid-js'
import { Show } from 'solid-js'
import { Title, Meta } from '@solidjs/meta'

export default function AiFansPolicy(props: { contentId: string; showSidebar?: boolean }) {
  const [title, setTitle] = createSignal('')
  const [metaTitle, setMetaTitle] = createSignal('')
  const [metaDescription, setMetaDescription] = createSignal('')
  const [body, setBody] = createSignal('')

  createEffect(async () => {
    const entry = await contentfulClient.getEntry<TypePolicySkeleton>(props.contentId)
    if (entry.fields.content) {
      setBody(documentToHtmlString(entry.fields.content))
    }
    if (entry.fields.title) {
      setTitle(entry.fields.title)
    }
    if (entry.fields.metaTitle) {
      setMetaTitle(entry.fields.metaTitle)
    }
    if (entry.fields.description) {
      setMetaDescription(entry.fields.description)
    }
  })

  return (
    <>
      <Title>{metaTitle()}</Title>
      <Meta name="og:title" content={metaTitle()} />
      <Meta name="description" content={metaDescription()} />
      <Meta name="og:description" content={metaDescription()} />

      <HeaderContainer />
      <main class="terms-of-service page-bg relative overflow-hidden bg-main pb-20 pt-20 font-normal sm:pt-28 md:bg-none md:pb-36">
        <div class="container relative z-20">
          <div class="wrapper gap-8 lg:flex">
            <Show when={props.showSidebar ?? true}>
              <AccountSidebar />
            </Show>

            {/* right */}
            <div class="right flex w-full flex-col">
              {/* head */}
              <div class="head gray-to-tran mb-7 rounded-xl text-[28px] font-semibold sm:p-4">
                <h2>{title()}</h2>
              </div>

              <div
                class="content gray-to-tran w-full rounded-xl prose-headings:text-2xl prose-headings:font-semibold prose-h2:mb-2 prose-h2:mt-4 prose-h2:text-2xl prose-h3:mb-1 prose-h3:mt-3 prose-h3:text-xl prose-p:my-4 prose-p:text-base prose-p:leading-relaxed sm:p-6"
                innerHTML={body()}
              ></div>
            </div>
          </div>
        </div>

        {/* bg */}
        <div class="radial-bg bottom-[-40%] left-[-250px] right-0 h-[1000px] w-[900px] opacity-10 md:hidden"></div>
      </main>
      <Footer />
    </>
  )
}
